import { Fragment, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Col, Modal, Form } from 'react-bootstrap';
// import LoadingIndicator from 'react-loading-indicator';
import ExcelUploader from '../FileUploader.js/ExcelUploader';
import { CommonLoading } from 'react-loadingg';
import { useHistory } from 'react-router';
import axios from 'axios';
import InsertNewHeader from './InsertNewHeader';
import * as FaIcons from 'react-icons/fa';


const InsertWorkerPerformanceGrade = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const [attachmentName, setAttachmentName] = useState('');
    const [totalRowUploaded, setTotalRowUploaded] = useState();
    const [isValidating, setIsValidating] = useState(true);
    const [excelValidated, setExcelValidated] = useState(false);
    const [previewData, setPreviewData] = useState([]);
    const [emptyCell, setEmptyCell] = useState([]);
    const [invalidBadgeIdCell, setInvalidBadgeIdCell] = useState([]);
    const [notNumericCell, setNotNumericCell] = useState([]);
    const [invalidGradeCell, setInvalidGradeCell] = useState([]);
    const [invalidGradeNameCell, setInvalidGradeNameCell] = useState([]);
    const [repeatedRow, setRepeatedRow] = useState([]);
    const [invalidColumnHeaders, setInvalidColumnHeader] = useState([]);
    // const styles = {
    //     .modal-style: {
    //         backgroundColor: 'rgba(0, 0, 0, 0.5)',
    //         display: 'flex',
    //         justifyContent: 'center',
    //         alignItems: 'center',
    //         zIndex: 9999,
    //         pointerEvents: 'all', // blocks all clicks
    //         background: '#fff',
    //         padding: '20px 30px',
    //         borderRadius: '8px',
    //         textAlign: 'center',
    //         fontSize: '30px'
    //     }
    // };

    const columnHeader = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
    const gradeList = ['A', 'B', 'C', 'D', 'E'];
    const gradeNameList = ['Top Performer', 'Above Average', 'Average', 'Below Average', 'Poor'];
    const tableData = [columnHeader, ...previewData];

    const location = useLocation();
    const history = useHistory();
    const { workerGradeList } = location.state || {};
    const { REACT_APP_API_BACKEND_URL, REACT_APP_AWS_REDIRECT_SIGNIN_URL } = process.env



    // Excel Validation
    useEffect(() => {
        const validation = () => {
            let emptyCellList = [];
            let invalidBadgeIdCellList = [];
            let notNumericCellList = [];
            let invalidGradeCellList = [];
            let invalidGradeNameCellList = [];
            let repeatedRowList = [];
            let invalidColumnHeaderList = [];
            for (let row = 1; row < tableData.length; row++) {

                tableData[row].map((cell, colIndex) => {

                    const cellValue = cell === undefined || cell === null ? '' : String(cell).trim();
                    const cellRef = columnHeader[colIndex] + row;
                    if (row == 1) {
                        // Invalid column headers 
                        if (columnHeader[colIndex] === "A" &&  cellValue !== 'full_name') {
                            invalidColumnHeaderList.push('full_name in ' + cellRef);
                        }

                        if (columnHeader[colIndex] === "B" && cellValue !== 'badge_id') {
                            invalidColumnHeaderList.push('badge_id in ' + cellRef);
                        }

                        if (columnHeader[colIndex] === "C" && cellValue !== 'factory') {
                            invalidColumnHeaderList.push('factory in ' + cellRef);
                        }

                        if (columnHeader[colIndex] === "D" && cellValue !== 'department') {
                            invalidColumnHeaderList.push('department in ' + cellRef);
                        }

                        if (columnHeader[colIndex] === "E" && cellValue !== 'grade') {
                            invalidColumnHeaderList.push('grade in ' + cellRef);
                        }

                        if (columnHeader[colIndex] === "F" && cellValue !== 'grade_name') {
                            invalidColumnHeaderList.push('grade_name in ' + cellRef);
                        }

                        if (columnHeader[colIndex] === "G" && cellValue !== 'year') {
                            invalidColumnHeaderList.push('year in ' + cellRef);
                        }

                        if (columnHeader[colIndex] === "H" && cellValue !== 'quarter') {
                            invalidColumnHeaderList.push('quarter in ' + cellRef);
                        }

                        if (columnHeader[colIndex] === "I" && cellValue !== 'created_by') {
                            invalidColumnHeaderList.push('created_by in ' + cellRef);
                        }
                    }

                    else {


                        // Empty Cell
                        if (cellValue === '') {
                            emptyCellList.push(cellRef);
                        }

                        // Invalid Badge ID
                        if (cellValue !== '' && columnHeader[colIndex] === "B" && isNaN(cell)) {
                            invalidBadgeIdCellList.push(cellRef);
                        }

                        // Not numeric in year, quarter
                        if (cellValue !== '' && (columnHeader[colIndex] === "G" || columnHeader[colIndex] === "H") && isNaN(cell)) {
                            notNumericCellList.push(cellRef);
                        }

                        // Invalid grade
                        if (cellValue !== '' && columnHeader[colIndex] === "E" && !gradeList.includes(String(cell).trim())) {
                            invalidGradeCellList.push(cellRef);
                        }

                        // Invalid grade_name
                        if (cellValue !== '' && columnHeader[colIndex] === "F" && !gradeNameList.includes(String(cell).trim())) {
                            invalidGradeNameCellList.push(cellRef);
                        }
                    }
                })
                // Contains Existing Records
                if (workerGradeList.filter((worker) => worker['badge_id'] === String(tableData[row][1]) && worker['year'] === String(tableData[row][6]) && worker['quarter'] === String(tableData[row][7])).length > 0) {
                    repeatedRowList.push("row " + row);
                }
            }
            console.log('emptyCellList = ', emptyCellList);
            console.log('invalidBadgeIdCellList = ', invalidBadgeIdCellList);
            console.log('notNumericCellList = ', notNumericCellList);
            console.log('invalidGradeCellList = ', invalidGradeCellList);
            console.log('invalidGradeNameCellList = ', invalidGradeNameCellList);
            console.log('repeatedRow = ', repeatedRowList);
            console.log('invalidColumnHeaderList = ', invalidColumnHeaderList);

            setEmptyCell(emptyCellList)
            setInvalidBadgeIdCell(invalidBadgeIdCellList)
            setNotNumericCell(notNumericCellList)
            setInvalidGradeCell(invalidGradeCellList)
            setInvalidGradeNameCell(invalidGradeNameCellList)
            setRepeatedRow(repeatedRowList)
            setInvalidColumnHeader(invalidColumnHeaderList)

            if (emptyCellList.length == 0 && invalidBadgeIdCellList.length == 0 && notNumericCellList.length == 0 && invalidGradeCellList.length == 0 && invalidGradeNameCellList.length == 0 && repeatedRowList.length == 0 && invalidColumnHeaderList.length == 0) {
                setExcelValidated(true);
            } else {
                setExcelValidated(false);
            }
        }

        validation();
        setIsValidating(false);
    }, [previewData])

    const ExportTemplateButton = (props) => {
        return (<Button
            variant='success'
            href={`${REACT_APP_AWS_REDIRECT_SIGNIN_URL}templates/worker_grading_template.xlsx`}
            download
            style={{ float: 'right' }}>
            Download Template Here
        </Button>);
    }

    const Template = () => {
        return (
            <div className="table-responsive table-headers">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th></th>
                            <th>A</th>
                            <th>B</th>
                            <th>C</th>
                            <th>D</th>
                            <th>E</th>
                            <th>F</th>
                            <th>G</th>
                            <th>H</th>
                            <th>I</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* 1 */}
                        <tr style={{ fontWeight: 'bold' }}>
                            <th>1</th>
                            <td>full_name</td>
                            <td>badge_id</td>
                            <td>factory</td>
                            <td>department</td>
                            <td>grade</td>
                            <td>grade_name</td>
                            <td>year</td>
                            <td>quarter</td>
                            <td>created_by</td>
                        </tr>
                        {/* 2 */}
                        <tr>
                            <th>2</th>
                            <td>Data start here</td>
                            <td>Data start here</td>
                            <td>Data start here</td>
                            <td>Data start here</td>
                            <td>Data start here</td>
                            <td>Data start here</td>
                            <td>Data start here</td>
                            <td>Data start here</td>
                            <td>Data start here</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    const onUpload = async (e) => {
        e.preventDefault(); // prevent the page from reloading
        setIsUploading(true);
        const rows = previewData.slice(1);
        const newDataSet = rows.map(row => ({
            'full_name': String(row[0]),
            'badge_id': String(row[1]),
            'factory': String(row[2]),
            'department': String(row[3]),
            'grade': String(row[4]),
            'grade_name': String(row[5]),
            'year': String(row[6]),
            'quarter': String(row[7]),
            'created_by': String(row[8])
        }));
        try {
            const url = REACT_APP_API_BACKEND_URL + '/api/workerGrade/insertWorkerRecords';
            const response = await axios.post(url, newDataSet, { headers: { 'Content-Type': 'application/json' } }
            );
            setIsUploading(false);
            switch (response.data.statusCode) {
                case "1":
                    alert("Worker Performance Grading Records have been successfully uploaded !")
                    history.goBack();
                    break;
                case "0":
                    alert("There are errors occurred when uploading Excel file. Please try again!")
                    break;
                default:
                    alert("Unknown captured. Please liaise with IT team.")
                    break;
            }

            // setIsUploading(false);
        } catch (e) {
            console.error(e);
            alert("Unknown error captured. Please liaise with IT team")
        }

    }

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${props.isActive ? 'container is-active' : 'container-fluid'
                            }`}
                    >
                        <InsertNewHeader />

                        <div className='table-wrapper'>
                            <h5 style={{ marginLeft: '10px' }}><strong>Instructions</strong></h5>
                            <hr />
                            <ul className='custom-list'>
                                <li>Please make sure to follow the template before upload the excel to the system. <ExportTemplateButton /></li>

                                <li>The column headers included: </li>
                                <ol className='custom-list'>
                                    <li><strong>full_name </strong>(Worker's Full Name)</li>
                                    <li><strong>badge_id </strong>(Worker's Badge ID)</li>
                                    <li><strong>factory</strong></li>
                                    <li><strong>department</strong></li>
                                    <li><strong>grade </strong>(A - E)</li>
                                    <li><strong>grade_name</strong></li>
                                    <li><strong>year </strong>(Calendar Year)</li>
                                    <li><strong>quarter </strong>(Sequence of evaluation in the same year)</li>
                                    <li><strong>created_by </strong>(Full name of HR that upload / prepare the excel)</li>
                                </ol>
                                <li>Please note that all fields are <strong>COMPULSORY</strong>.</li>
                            </ul>

                        </div>
                        <br />
                        <div className='table-wrapper'>
                            <h5><strong style={{ marginLeft: '10px' }}>Sample Excel Content</strong></h5>
                            <hr />
                            <Template />
                        </div>
                        <br />
                        <div className='table-wrapper'>
                            <h5 style={{ marginLeft: '10px' }}><strong>Upload</strong></h5>
                            <hr />
                            <ExcelUploader setPreviewData={setPreviewData} setAttachmentName={setAttachmentName} setTotalRowUploaded={setTotalRowUploaded} />
                        </div>
                        <br />
                        {
                            previewData.length > 0 ?
                                //isValidating === false ?
                                <div className='table-wrapper'>
                                    {excelValidated ? (
                                        <Form onSubmit={onUpload}><div>
                                            <h5><strong>Preview</strong></h5>
                                            <hr />
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',     // horizontal center
                                                justifyContent: 'center', // vertical center (optional)
                                            }}>
                                                <Button
                                                    value='Submit'
                                                    type='submit'
                                                    variant='success'
                                                    // href='/templates/worker_grading_template.xlsx'
                                                    // download
                                                    style={{ float: 'right' }}>
                                                    <FaIcons.FaUpload style={{ marginRight: '7px' }} />Upload
                                                </Button>
                                                <br />
                                                <center><h6><span style={{ fontWeight: 'bold' }}>File name:  </span>{attachmentName}</h6></center>
                                                <center><h6><span style={{ fontWeight: 'bold' }}>Total Rows:  </span>{totalRowUploaded - 1}</h6></center>
                                                <br />
                                            </div>
                                            <table className="table table-bordered">
                                                <tbody>

                                                    {tableData.map((row, rowIndex) => (

                                                        <tr key={rowIndex}>
                                                            {rowIndex === 0 ? <th style={{ backgroundColor: 'lightgrey' }}></th> : <th style={{ backgroundColor: 'lightgrey', textAlign: 'center' }}>{rowIndex}</th>}
                                                            {row.map((cell, colIndex) => (
                                                                rowIndex === 0 || rowIndex === 1 ?
                                                                    <th key={colIndex} style={{ backgroundColor: 'lightgrey', fontWeight: 'bold', textAlign: 'center' }}>
                                                                        {cell ?? " "}
                                                                    </th> :
                                                                    <td key={colIndex}>
                                                                        {cell ?? " "}
                                                                    </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        </Form>
                                    ) : <div className='table-wrapper error-cell-wrapper'>
                                        <strong>Please check on below cells in the excel file and upload again.</strong>
                                        <br />
                                        {(invalidColumnHeaders.length > 0 && (
                                            <div className='error-cell-wrapper'>
                                                <strong>Invalid Column Headers Detected: </strong>
                                                <strong style={{ color: 'red', textAlign: 'center' }}>{invalidColumnHeaders.join(', ')}</strong>
                                                <br />
                                            </div>)
                                        )}
                                        {(emptyCell.length > 0 && (
                                            <div className='error-cell-wrapper'>
                                                <strong>Empty Cells Detected: </strong>
                                                <strong style={{ color: 'red', textAlign: 'center' }}>{emptyCell.join(', ')}</strong>
                                                <br />
                                            </div>)
                                        )}
                                        {invalidBadgeIdCell.length > 0 && (
                                            <div className='error-cell-wrapper'>
                                                <strong>Invalid Badge ID Cells: </strong>
                                                <strong style={{ color: 'red' }}>{invalidBadgeIdCell.join(', ')}</strong>
                                                <br />
                                            </div>

                                        )}
                                        {notNumericCell.length > 0 && (
                                            <div className='error-cell-wrapper'>
                                                <strong>Non-numeric Cells: </strong>
                                                <strong style={{ color: 'red' }}>{notNumericCell.join(', ')}</strong>
                                                <br />
                                            </div>

                                        )}
                                        {invalidGradeCell.length > 0 && (
                                            <div className='error-cell-wrapper'>
                                                <strong>Invalid Grade: </strong>
                                                <strong style={{ color: 'red' }}>{invalidGradeCell.join(', ')}</strong>
                                                <br />
                                            </div>

                                        )}

                                        {invalidGradeNameCell.length > 0 && (
                                            <div className='error-cell-wrapper'>
                                                <strong>Invalid Grade Name: </strong>
                                                <strong style={{ color: 'red' }}>{invalidGradeNameCell.join(', ')}</strong>
                                                <br />
                                            </div>
                                        )}

                                        {repeatedRow.length > 0 && (
                                            <div className='error-cell-wrapper'>
                                                <strong>Repeated Rows (Badge ID, Year & Quarter): </strong>
                                                <strong style={{ color: 'red' }}>{repeatedRow.join(', ')}</strong>
                                                <br />
                                            </div>
                                        )}
                                    </div>}
                                </div> : null
                        }
                    </div>
                </div>

            ) }
            {isUploading && (
                <Modal
                    show={true}
                    centered
                    backdrop='static'
                    keyboard={false}
                >
                    <Modal.Body style={{ textAlign: 'center', padding: '30px', fontSize: '25px' }}>
                        {/* <div style={styles.overlay} > */}
                        <div className='modal-style'>
                            <div className='spinner' />
                            Upload in progress...
                        </div>

                        {/* </div> */}
                    </Modal.Body>
                </Modal>
            )}
        </Fragment>
    );

}

export default InsertWorkerPerformanceGrade;